import axios from 'axios'

// initial state
const state = {
    all: [],
    custom: [],
    categories: {
        "": "drop_all_products",
        "product": "drop_ptype_product",
        "accessory": "drop_title_accessory",
        "mosaic": "drop_ptype_mosaic2",
        "mosaic3": "drop_ptype_mosaic3",
        "puzzle": "drop_ptype_puzzle",
        "canvas": "drop_ptype_canvas",
        "paint": "drop_ptype_paint",
    },
}

// getters
const getters = {}

// actions
const actions = {
    async getAllProducts({commit}) {
        let response = await axios.get('products/')
        if (response.data.success && response.data.data) {
            commit('setProducts', response.data.data.products)
            commit('setCustom', response.data.data.custom)
            commit('setCategories', response.data.data.categories)
            return response.data.data.products;
        }
    },
    refreshStock({commit}, products) {
        commit('setProducts', products)
    }
}

// mutations
const mutations = {
    setProducts(state, products) {
        state.all = products

    },
    setCustom(state, products) {
        state.custom = products

    },
    setCategories(state, categories) {
        state.categories = categories

    },
    refreshStock(state, products) {
        products.forEach((item, i, products) => {
            const id = getPid(item.id);
            const product = state.all.find(product => (product.id === id && product.stock > 0))
            if (!product) {
                products.splice(i, 1);
            } else {
                product.stock -= item.quantity
                if (product.stock < 0) {
                    products[i].quantity += product.stock;
                    product.stock = 0;

                }
            }
        })
    },

    incrementProductInventory(state, {id, count}) {
        id = getPid(id);
        const product = state.all.find(product => product.id === id)
        product.stock += count
    },

    decrementProductInventory(state, {id, count}) {
        id = getPid(id);
        const product = state.all.find(product => product.id === id)
        product.stock -= count
    }
}

const getPid = (id) => {
    if (!Number.isInteger(id) && id.includes('_')) {
        return parseInt(id.split('_')[0])
    }
    return id;
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}